import "./blog.css";
import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Redirect } from 'react-router';

export default class Blog extends Component {
  render() {
    return (
      <Redirect to={"https://cuisinecrafters.net/blog"} />
    );
  }
}
